import BaseViz from './BaseViz'
import BarChartChart from '../charts/BarChartChart'
import BarChartDataController from '../viz_behaviors/BarChartDataController'
import ProgressBarChartDataController from '../viz_behaviors/ProgressBarChartDataController'
import { formatNumber } from '../utils/formatUtils'
export default class ProgressBarChartViz extends BaseViz {
  static defaultConfig = {
    /**
     * {-EN-} If set to `true`, sector values will be show as a percentage of the total.
     * {-ES-} Si se establece en `true`, los valores del sector se mostrarán como un porcentaje del total.
     */
    showPercentage: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    placeholderColor: {
      type: String,
      default: 'tint', //'#f6fafc',
      exposed: true,
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
      },
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
          exposed: false,
        },
        valueFormat: {
          nonEditable: true,
          exposed: false,
        },
        unit: {
          nonEditable: true,
          exposed: false,
        },
        scale: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
        domain: {
          nonEditable: true,
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        const mainBar = $el.querySelector('.main-path')
        let original = (mainBar || $el).getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
      getHtml: function (d) {
        let formatter = (value, format) => {
          let match = this.matchFormatString(format || '')
          let numberFormat = match && match[2]
          let thouDel = this.config.thousandsDelimiter
          let decDel = this.config.decimalDelimiter
          return formatNumber(value, numberFormat, thouDel, decDel)
        }
        return `
          <div class="tip-value important">${this.formatTooltipValue(d.value, 'y')}</div>
          <div class="tip-id">
            <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
              { id: d.id }
            )}; margin-right: 3px"></span>
            ${d.id}
          </div>
          ${
            this.config.showPercentage
              ? '<div class="secondary">' +
                formatter(d.percent, this.config.percentageFormat) +
                '%</div>'
              : ''
          }
          `
      },
    },
  }
  static chartClass = BarChartChart
  static dataControllerClass = ProgressBarChartDataController
}
